import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { catchError } from "rxjs/operators";

/**
 * パス「/before_login」以下のAPIに関するクラス
 */
@Injectable({
  providedIn: "root",
})
export class BeforeLoginApi {
  /**
   * コンストラクタ
   */
  constructor(
    private httpClient: HttpClient
  ) {}

  /** GET */
  /**
   * ログイン前のJSONを取得する
   * - APIパス：/before_login/json
   * - pipe
   *    - コンソールにエラーを表示
   * @returns Observable<Object>型のレスポンス
   */
  getInfoJson(): Observable<Object> {
    const url = `${environment.apiUrl}/before_login/json`;
    return this.httpClient
      .get(url, {
        headers: new HttpHeaders({
          "x-api-key": environment.apiKey,
          "Content-Type": "application/json",
        }),
      })
      .pipe(
        catchError((error) => {
          console.error("ログイン画面メッセージが取得できませんでした。");
          console.error(error);
          return error;
        })
      );
  }
}
